(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
  var viewport = window.innerHeight || 800;
  var targets = sections.filter(function (section, index) {
    if (index === 0) return false;
    return section.getBoundingClientRect().top > viewport * 0.9;
  });
  if (!targets.length) return;

  targets.forEach(function (section) {
    section.classList.add('lmds-reveal-item');
  });
  document.documentElement.classList.add('lmds-reveal');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  targets.forEach(function (section) {
    observer.observe(section);
  });

  window.addEventListener('pagehide', function () {
    targets.forEach(function (section) {
      section.classList.add('is-in');
    });
  });
})();
